import styled, { keyframes } from "styled-components";
import FONTS from "../../constants/fonts";
import ICONS from "../../constants/icons";

const shadowAnim = keyframes`
	0% {
		box-shadow: 0 0 14px 1px #0096c6;
	}

	25% {
		box-shadow: 0 0 94px 1px #0096c6;
	}

	50% {
		box-shadow: 0 0 14px 1px #0096c6;
	}
	75% {
		box-shadow: 0 0 94px 1px #0096c6;
	}
	100% {
		box-shadow: 0 0 14px 1px #0096c6;
	}
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;


const fadeIn = keyframes`
  0% {opacity:0;}
  100% {opacity:1;}
`;

export const WholeWrapper = styled.div`
  min-width: 100%;
  min-height: 100vh;
  max-width: 100%;
  max-height: 100vh;
  background-image: url(${ICONS.Background});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  padding: 6.4rem 3.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-family: ${FONTS.UbuntuRegular};
  font-size: 7rem;
  line-height: 8rem;
  color: #fff;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 18px rgba(0, 150, 198, 0.95);
  padding: 2.4rem 0;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-family: ${FONTS.UbuntuRegular};
  line-height: 5.2rem;
  font-size: 4.8rem;
  padding: 0rem 0;
  color: #fff;
  text-align: center;
`;

export const AnimationWrapper = styled.div`
  min-width: 200px;
  max-width: 200px;
  min-height: 200px;
  max-height: 200px;
  position: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 3.2rem 0 3rem;
  border-radius: 50%;
  animation: ${shadowAnim} 3.2s infinite, ${fadeIn} 3.2s;
  animation-timing-function:ease-in-out;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  left: -36px;
  top: -36px;
`;
